// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"652":"71fefa31","791":"d55464fe"}[chunkId] + ".chunk.js";
};